module.exports = __webpack_public_path__ + "img/深色图例1.2d3a1bf8.png";